import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { colors } from "../../../../ui/colors"
import { ArrowLeftIcon } from "../../../../ui/icons/arrow-left"
import { Layout } from "../../../../ui/layout"
import { ButtonComponent } from "../../../../ui/molecules/button/newButton"
import { Banner } from "../../../../ui/organisms/banner"
import { MenuItems } from "../../../../ui/organisms/navbar/dto"
import { RightBar } from "../../../../ui/organisms/rightBar"
import { SuccessPopup } from "../../../../ui/organisms/successPopup"
import { ComplianceRequestsCreation, ComplianceRequetsValidation, resetComplianceRequestsValidationStatus, resetCreateStatus, setFromCreationToUpdate, setRequestCustomerDataId, setRequestOfficerId } from "../slice"
import { AddStateRequest } from "./addStateRequest"
import { AddFormRequest } from "./form"

export function AddComplianceRequest() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const sessionState = useAppSelector(state => state.session)
    const complianceRequestState = useAppSelector(state => state.complianceRequest)
    const userState = useAppSelector(state => state.users)
    const [showSuccess, setShowSuccess] = useState<boolean>(false)

    useEffect(() => {
        dispatch(setRequestCustomerDataId(sessionState.selected.customerId))
        dispatch(setRequestOfficerId(userState.findMeResponse.id))
    }, [dispatch, sessionState.selected.customerId, userState.findMeResponse.id])

    useEffect(() => {
        if (complianceRequestState.complianceRequestCreationStatus === 'successfully') {
            dispatch(setFromCreationToUpdate(true))
            setShowSuccess(true)
            dispatch(resetCreateStatus())
            const timer = setTimeout(() => {
                setShowSuccess(false)
                navigate('/complianceRequests')
            }, 2000);

            return () => clearTimeout(timer)
        }
    }, [complianceRequestState.complianceRequestCreationStatus, dispatch, navigate])

    useEffect(() => {
        if (complianceRequestState.complianceRequestErrorsStatus === 'successfully') {
            dispatch(resetComplianceRequestsValidationStatus())
            dispatch(ComplianceRequestsCreation(complianceRequestState.complianceRequestsCreation))
        }
    }, [complianceRequestState.complianceRequestErrorsStatus])

    if (sessionState.selected.customerId) {
        return (
            <Layout
                menuItem={MenuItems.GESTIONE_CERTIFICAZIONE}
                breadcrumbItems={['Gestione Certificazione', 'Richieste Conformità', 'Nuova Richiesta']}
                headerLabel="Nuova Richiesta"
                rightBar={true}
                headerIcon={
                    <ArrowLeftIcon onClick={() => navigate('/complianceRequests')} color={colors.white} />
                }
                headerChildren={
                    <div className="flex items-center h-full w-full justify-end">
                        <ButtonComponent
                            size={"sm"}
                            iconPosition={"off"}
                            variant={"solid"}
                            label="Salva"
                            color={"orange"}
                            onClick={() => {
                                dispatch(ComplianceRequetsValidation(complianceRequestState.complianceRequestsCreation))
                            }}
                        />
                    </div>
                }
            >
                <div className="flex h-full min-h-full flex-col">
                    {
                        (showSuccess) &&
                        <div className="px-6 pt-3 pb-1 flex flex-col gap-2">
                            <SuccessPopup
                                active={showSuccess}
                                message="Dati salvati correttamente."
                                onClose={() => {
                                    dispatch(resetCreateStatus())
                                    setShowSuccess(false)
                                }}
                            />
                        </div>
                    }
                    <div className="flex h-full flex-1 min-h-0 overflow-hidden">
                        <div className="flex-[0.6] h-full overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none] bg-neutral-50 border-r border-neutral-200">
                            <AddFormRequest />
                        </div>
                        <div className="flex-[0.4] h-full overflow-y-auto bg-white">
                            <RightBar disabled={!complianceRequestState.fromCreationToUpdate}>
                                <AddStateRequest />
                            </RightBar>
                        </div>
                    </div>
                </div>
            </Layout>
        )
    }
    return (
        <Banner
            type="error"
            visible={!sessionState.selected.customerId}
            label={"Devi prima selezionare un cliente per accedere all'area"}
            closeAction={function (): void {
                alert("Devi prima selezionare un cliente per accedere all'area")
            }}
        />
    )
}